import { Polygon } from "fabric";
import { InteractableCanvasElementProps } from "../Canvas";

export { rightAngleTriangle };

type Props = {
  x: number;
  y: number;
  height: number;
  width: number;
  color: string;
  opacity: number;
  draggable: boolean;
} & InteractableCanvasElementProps;

function rightAngleTriangle(props: Props) {
  const polyWidth = 10;
  const polyHeight = 10;
  const dragPolygonSize = {
    // at most full height of rect, or 10px ?
    width: polyWidth,
    height: polyHeight,
  };
  const resizeData = props.draggable
    ? {
        resizeId: props.id,
        minWidth: polyWidth * 1.5,
        minHeight: polyHeight * 1.5,
      }
    : undefined;
  return new Polygon(
    // create points at bottom right of rect to create a right angle triangle relative to local coords
    [
      // bottom right triangle
      {
        x: 0,
        y: 0,
      },
      // top of triangle
      {
        x: 0,
        y: -dragPolygonSize.height,
      },
      // bottom left of triangle
      {
        x: -dragPolygonSize.width,
        y: 0,
      },
    ],
    {
      data: resizeData,
      // don't show border on drag control
      hasBorders: false,
      // don't show fabric controls ever
      hasControls: false,
      // don't ever allow rotation
      lockRotation: true,

      originX: "right",
      originY: "bottom",
      // don't allow movement
      lockMovementX: true,
      lockMovementY: true,
      // position of bottom right of rect, relative to group top-left
      left: props.width + 1,
      top: props.height + 1,
      // dimension is larger than drawn image, makes target more useable
      width: polyWidth * 2.5,
      height: polyHeight * 2.5,
      // styling
      fill: "cornflowerblue",
      opacity: props.opacity,
      stroke: "cornflowerblue",
      hoverCursor: "grab",
      // let events run
      evented: true,
    },
  );
}
